export default {
  alert: {
    title: 'Информация',
    ok: 'Ок',
  },
  confirm: {
    title: 'Подтверждение',
    ok: 'Ок',
    cancel: 'Отмена',
  },
};
